var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowDown = function SvgArrowDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06595 5.68552L8.59511 0.995039C8.66788 0.89472 8.70638 0.780982 8.70678 0.66514C8.70719 0.549297 8.66949 0.435389 8.59744 0.334747C8.52538 0.234105 8.42148 0.150238 8.29607 0.0914898C8.17066 0.0327415 8.02811 0.00115913 7.88261 -0.000114036L0.824281 -0.000114653C0.678781 0.00115849 0.536235 0.0327408 0.410826 0.0914891C0.285417 0.150237 0.181515 0.234104 0.109458 0.334746C0.0374026 0.435388 -0.000298023 0.549296 0.000110139 0.665139C0.000517348 0.780981 0.0390172 0.894719 0.111781 0.995038L3.64095 5.68552C3.71523 5.78301 3.81981 5.86362 3.94462 5.91956C4.06942 5.97549 4.21022 6.00488 4.35345 6.00488C4.49667 6.00488 4.63748 5.97549 4.76228 5.91956C4.88708 5.86362 4.99167 5.78301 5.06595 5.68552Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ArrowDown.c87c02db.svg";
export { ForwardRef as ReactComponent };